import { formatIndianCurrency, isDiscountInputAllowed } from "@utils";
import React, { useMemo } from "react";

function QuotationSummaryStatsRow({
  productList,
  manifoldProductList,
  showDiscount = true,
  readOnly,
  formData,
  handleFormValueChange,
}) {
  const totalStats = useMemo(() => {
    const totalStats = {
      qty: 0,
      totalNetAmount: 0,
      totalAmount: 0,
      totalDiscountedAmount: 0,
      totalAmountAfterDiscount: 0,
      totalPNetAmount: 0,
      totalPAmount: 0,
    };
    const nouse = productList.forEach((prod) => {
      const nouse = prod?.productItems?.forEach((productItem) => {
        if (productItem?.action !== "delete") {
          totalStats.qty += Number(productItem.quantity);
          totalStats.totalAmount += Number(productItem.sales_total_amount);
          totalStats.totalNetAmount += Number(productItem.sales_net_amount);
          totalStats.totalPAmount += Number(productItem.purchase_total_amount);
          totalStats.totalPNetAmount += Number(productItem.purchase_net_amount);
        }
      });
      console.log(nouse);
    });
    console.log(nouse);

    const nouse2 = manifoldProductList?.forEach((productItem) => {
      if (productItem?.action !== "delete") {
        totalStats.qty += Number(productItem.quantity);
        totalStats.totalAmount += Number(productItem.sales_total_amount);
        totalStats.totalNetAmount += Number(productItem.sales_net_amount);
        totalStats.totalPAmount += Number(productItem.purchase_total_amount);
        totalStats.totalPNetAmount += Number(productItem.purchase_net_amount);
      }
    });
    console.log(nouse2);

    // totalStats.totalAmount = Math.round(
    //   (
    //     totalStats.totalAmount -
    //     (totalStats.totalAmount * Number(formData?.extra_discount ?? 0)) / 100
    //   ).toFixed(2)
    // );
    totalStats.totalDiscountedAmount = Math.round(
      (totalStats.totalAmount * Number(formData?.extra_discount ?? 0)) / 100
    );
    totalStats.totalAmountAfterDiscount = Math.round(
      (totalStats.totalAmount - totalStats.totalDiscountedAmount).toFixed(2)
    );

    return totalStats;
  }, [productList, manifoldProductList, formData]);
  return (
    <>
      <tr
        id={2}
        style={{
          backgroundColor: "rgba(0, 0, 0, 0.075)",
        }}
      >
        <td></td>
        <td></td>
        <td
          className="float-right"
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            flexDirection: "row",
          }}
        >
          <input
            className="form-control position-relative"
            type="text"
            name="Total"
            value={"Total"}
            readOnly
            style={{
              backgroundColor: "transparent",
              border: "none",
              fontWeight: "bold",
              width: showDiscount ? "40%" : "35%",
            }}
          />
        </td>
        <td>
          <div className="form-group">
            <div
              className="form-control position-relative"
              style={{
                backgroundColor: "transparent",
                border: "none",
                fontWeight: "bold",
                textAlign: "right",
              }}
            >
              {totalStats.qty}
            </div>
          </div>
        </td>
        <td></td>
        <td></td>
        <td>
          <div className="form-group">
            <div
              className="form-control position-relative"
              style={{
                backgroundColor: "transparent",
                border: "none",
                fontWeight: "bold",
                textAlign: "right",
              }}
            >
              {formatIndianCurrency(totalStats.totalNetAmount)}
            </div>
          </div>
        </td>
        <td>
          <div className="form-group">
            <div
              className="form-control position-relative"
              style={{
                backgroundColor: "transparent",
                border: "none",
                fontWeight: "bold",
                textAlign: "right",
              }}
            >
              {formatIndianCurrency(totalStats.totalAmount)}
            </div>
          </div>
        </td>
        <td></td>
        <td>
          <div className="form-group">
            <div
              className="form-control position-relative"
              style={{
                backgroundColor: "transparent",
                border: "none",
                fontWeight: "bold",
                textAlign: "right",
              }}
            >
              {formatIndianCurrency(totalStats.totalPNetAmount)}
            </div>
          </div>
        </td>
        <td>
          <div className="form-group">
            <div
              className="form-control position-relative"
              style={{
                backgroundColor: "transparent",
                border: "none",
                fontWeight: "bold",
                textAlign: "right",
              }}
            >
              {formatIndianCurrency(totalStats.totalPAmount)}
            </div>
          </div>
        </td>
      </tr>
      {showDiscount && (
        <>
          <tr
            id={3}
            style={{
              backgroundColor: "rgba(0, 0, 0, 0.075)",
            }}
          >
            <td colSpan={2}></td>
            <td
              className="float-right"
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                flexDirection: "row",
              }}
            >
              {showDiscount && (
                <>
                  <input
                    className="form-control position-relative"
                    type="text"
                    name="Discount"
                    value="Discount %"
                    readOnly
                    style={{
                      backgroundColor: "transparent",
                      border: "none",
                      fontWeight: "bold",
                      width: "40%",
                    }}
                  />
                  <input
                    className="form-control position-relative"
                    type="text"
                    name="extra_discount"
                    placeholder="Discount %"
                    inputMode="decimal"
                    value={formData?.extra_discount}
                    readOnly={readOnly}
                    onChange={(e) => {
                      // Up to two decimals, same as the per-item discounts.
                      if (!isDiscountInputAllowed(e.target?.value)) {
                        return;
                      }
                      handleFormValueChange(e);
                    }}
                    style={{
                      fontWeight: "bold",
                      width: "50%",
                    }}
                  />
                </>
              )}
            </td>
            <td colSpan={4}></td>

            <td>
              <div className="form-group">
                <div
                  className="form-control position-relative"
                  style={{
                    backgroundColor: "transparent",
                    border: "none",
                    fontWeight: "bold",
                    textAlign: "right",
                  }}
                >
                  -{formatIndianCurrency(totalStats.totalDiscountedAmount)}
                </div>
              </div>
            </td>
            <td colSpan={3}></td>
          </tr>
          <tr
            id={4}
            style={{
              backgroundColor: "rgba(0, 0, 0, 0.075)",
            }}
          >
            <td colSpan={2}></td>
            <td
              className="float-right"
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                flexDirection: "row",
              }}
            >
              <input
                className="form-control position-relative"
                type="text"
                name="Total Amount"
                value="Total Amount"
                readOnly
                style={{
                  backgroundColor: "transparent",
                  border: "none",
                  fontWeight: "bold",
                  width: "100%",
                }}
              />
            </td>
            <td colSpan={4}></td>

            <td>
              <div className="form-group">
                <div
                  className="form-control position-relative"
                  style={{
                    backgroundColor: "transparent",
                    border: "none",
                    fontWeight: "bold",
                    textAlign: "right",
                  }}
                >
                  {formatIndianCurrency(totalStats.totalAmountAfterDiscount)}
                </div>
              </div>
            </td>
            <td colSpan={3}></td>
          </tr>
        </>
      )}
    </>
  );
}

export default React.memo(QuotationSummaryStatsRow);
